/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
import React from 'react';

export const AIModeIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
		<g clipPath="url(#paint0_angular_1444_20602_clip_path)">
			<g transform="matrix(0.00603823 -0.00586347 0.00586347 0.00603823 8.9423 6.1482)">
				<foreignObject x="-1671.7" y="-1671.7" width="3343.4" height="3343.4">
					<div
						style={{
							background:
								'conic-gradient(from 90deg,rgba(252, 167, 0, 1) 0deg,rgba(252, 167, 0, 1) 72.6913deg,rgba(106, 153, 34, 1) 72.7273deg,rgba(106, 153, 34, 1) 167.895deg,rgba(24, 104, 219, 1) 167.931deg,rgba(24, 104, 219, 1) 252.667deg,rgba(175, 89, 224, 1) 252.703deg,rgba(175, 89, 224, 1) 360deg)',
							height: '100%',
							width: '100%',
							opacity: 1,
						}}
					/>
				</foreignObject>
			</g>
		</g>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.9502 3.55469C4.46491 3.55469 2.4502 5.56941 2.4502 8.05469C2.4502 10.54 4.46491 12.5547 6.9502 12.5547C8.19304 12.5547 9.31701 12.0518 10.1322 11.2367C10.9473 10.4215 11.4502 9.29754 11.4502 8.05469C11.4502 5.56941 9.43548 3.55469 6.9502 3.55469ZM0.950195 8.05469C0.950195 4.74098 3.63649 2.05469 6.9502 2.05469C10.2639 2.05469 12.9502 4.74098 12.9502 8.05469C12.9502 9.44091 12.4794 10.7182 11.69 11.7339L14.9805 15.0244L13.9199 16.085L10.6294 12.7945C9.61368 13.5839 8.33641 14.0547 6.9502 14.0547C3.63649 14.0547 0.950195 11.3684 0.950195 8.05469Z"
		/>
		<rect x="6.99316" y="0.18457" width="8.11127" height="8.11127" fill="#F8F8F8" />
		<g clipPath="url(#paint1_angular_1444_20602_clip_path)">
			<g transform="matrix(0.0035 -0.00438306 0.00438306 0.0035 11.0488 4.24023)">
				<foreignObject x="-1127.54" y="-1127.54" width="2255.08" height="2255.08">
					<div
						style={{
							background:
								'conic-gradient(from 90deg,rgba(252, 167, 0, 1) 0deg,rgba(252, 167, 0, 1) 72.6913deg,rgba(106, 153, 34, 1) 72.7273deg,rgba(106, 153, 34, 1) 167.895deg,rgba(24, 104, 219, 1) 167.931deg,rgba(24, 104, 219, 1) 252.667deg,rgba(175, 89, 224, 1) 252.703deg,rgba(175, 89, 224, 1) 360deg)',
							height: '100%',
							width: '100%',
							opacity: 1,
						}}
					/>
				</foreignObject>
			</g>
		</g>
		<path d="M11.165 0.749023C11.4317 0.790659 11.6594 0.974255 11.7539 1.2334L12.3682 2.91992L14.0557 3.53516C14.3517 3.64314 14.5488 3.92513 14.5488 4.24023L14.54 4.35645C14.4984 4.62306 14.3148 4.85079 14.0557 4.94531L12.3682 5.55957L11.7539 7.24707C11.6594 7.50621 11.4317 7.68981 11.165 7.73145L11.0488 7.74023C10.7337 7.74023 10.4517 7.5431 10.3438 7.24707L9.72852 5.55957L8.04199 4.94531C7.78285 4.85079 7.59925 4.62306 7.55762 4.35645L7.54883 4.24023C7.54883 3.92513 7.74597 3.64314 8.04199 3.53516L9.72852 2.91992L10.3438 1.2334C10.4383 0.974255 10.666 0.790659 10.9326 0.749023L11.0488 0.740234L11.165 0.749023Z" />
		<defs>
			<clipPath id="paint0_angular_1444_20602_clip_path">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.9502 3.55469C4.46491 3.55469 2.4502 5.56941 2.4502 8.05469C2.4502 10.54 4.46491 12.5547 6.9502 12.5547C8.19304 12.5547 9.31701 12.0518 10.1322 11.2367C10.9473 10.4215 11.4502 9.29754 11.4502 8.05469C11.4502 5.56941 9.43548 3.55469 6.9502 3.55469ZM0.950195 8.05469C0.950195 4.74098 3.63649 2.05469 6.9502 2.05469C10.2639 2.05469 12.9502 4.74098 12.9502 8.05469C12.9502 9.44091 12.4794 10.7182 11.69 11.7339L14.9805 15.0244L13.9199 16.085L10.6294 12.7945C9.61368 13.5839 8.33641 14.0547 6.9502 14.0547C3.63649 14.0547 0.950195 11.3684 0.950195 8.05469Z"
				/>
			</clipPath>
			<clipPath id="paint1_angular_1444_20602_clip_path">
				<path d="M11.165 0.749023C11.4317 0.790659 11.6594 0.974255 11.7539 1.2334L12.3682 2.91992L14.0557 3.53516C14.3517 3.64314 14.5488 3.92513 14.5488 4.24023L14.54 4.35645C14.4984 4.62306 14.3148 4.85079 14.0557 4.94531L12.3682 5.55957L11.7539 7.24707C11.6594 7.50621 11.4317 7.68981 11.165 7.73145L11.0488 7.74023C10.7337 7.74023 10.4517 7.5431 10.3438 7.24707L9.72852 5.55957L8.04199 4.94531C7.78285 4.85079 7.59925 4.62306 7.55762 4.35645L7.54883 4.24023C7.54883 3.92513 7.74597 3.64314 8.04199 3.53516L9.72852 2.91992L10.3438 1.2334C10.4383 0.974255 10.666 0.790659 10.9326 0.749023L11.0488 0.740234L11.165 0.749023Z" />
			</clipPath>
		</defs>
	</svg>
);
